import { KuxMediaAssetType } from '@kaltura-ott/tvpil';

export const getParentalRatingString = <T extends KuxMediaAssetType>(data?: T): undefined | string => {
  if (!data) return undefined;
  if (!data.tags['ParentalRating'] || !data.tags['ParentalRating'][0]) return undefined;
  const parseRating = data.tags['ParentalRating'] ? parseInt(data.tags['ParentalRating'][0], 10) : 0;

  return parseRating < 0 ? undefined : data.tags['ParentalRating'][0];
};
